import { useCallback, useEffect } from 'react'

// Handles automatic report selection in two scenarios:
// 1. When reports are fetched from the server - selects the first report if none is selected
// 2. When a new report is created - selects the newly created report
export const useReportSelection = ({ selectedReport, setSelectedReport, wasCreated, createSroiReportPayload }) => {
  // Auto-select newly created report when creation completes
  useEffect(() => {
    if (wasCreated && createSroiReportPayload) {
      setSelectedReport(createSroiReportPayload)
    }
  }, [wasCreated, createSroiReportPayload, setSelectedReport])

  const onFetchedOptionsChange = useCallback(
    options => {
      if (
        options?.length &&
        // Auto-select first report when options are fetched and nothing is selected yet
        (!selectedReport ||
          // Handle case when option was deleted from the list
          options.findIndex(option => option.id === selectedReport.id) === -1)
      ) {
        setSelectedReport(options[0])
      } else if (selectedReport && !options.length) {
        // handle the case when the last report was deleted
        setSelectedReport(null)
      }
    },
    [selectedReport, setSelectedReport]
  )

  return onFetchedOptionsChange
}
